import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const stylesBase = (theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      height: '100vh',
      minHeight: 750,
      justifyContent: 'flex-start',
      backgroundColor: '#F5F6F8',
    },
    block: {
      padding: 24,
      width: 320,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      backgroundColor: '#fff',
    },
    form: {
      width: '100%',
      borderRadius: 20,
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    errorBlock: {
      position: 'absolute',
      width: 444,
      top: 89,
    },
    contactInfoWrapper: {
      padding: 8,
      backgroundColor: '#F1F5F9',
      borderRadius: 8,
      '& > div:first-child)': {
        marginBottom: 16,
      },
      '& > div:nth-last-child(2)': {
        marginBottom: 0,
        marginTop: 16,
      },
      '& a': {
        textDecoration: 'none',
        '&:active': {
          color: 'initial',
        },
      },
    },
    contactInfoLabel: {
      color: '#7D7E8C',
      fontSize: 14,
    },
    contactInfoValue: {
      color: '#7D7E8C',
      fontSize: 16,
      marginBottom: 16,
    },
    contactItem: {
      color: '#18181C',
      fontSize: 11,
    },
  });

export const useStyles = makeStyles(theme => ({
  ...stylesBase(theme),
}));
